import React, { useEffect, useState } from 'react';
import { Grid, Box, Button, Card, CardContent, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { useSnackbar } from 'notistack';
import CompanyData from '../CompanyData';
import { styles } from './styles';
import { useDisplayCompanyMutation } from '../../../api/company';
import { CompanyMenu } from '../CompanyMenu';
import ActionButton from '../../../components/common/ActionButtonAndMenu/ActionButton';

const View = (props) => {
    const navigate = useNavigate();
    const params = useParams();
    const { enqueueSnackbar } = useSnackbar();
    const [companyDetails, setCompanyDetails] = useState();

    const [displayCompany, { isLoading: isDisplayLoading }] = useDisplayCompanyMutation();

    useEffect(() => {
        async function fetchData() {
            const bodyFormData = new FormData();
            bodyFormData.append('id', params.id);
            try {
                const response = await displayCompany(bodyFormData).unwrap();
                if (!response) return;
                if (response?.status === 'ERROR') throw new Error(response?.message);
                setCompanyDetails(response);
            } catch (err) {
                if (err?.statusCode === 400) enqueueSnackbar(err?.data?.message, { variant: 'error' });
                else
                    enqueueSnackbar(err?.message || 'Something went wrong! Customer could not be fetched.', {
                        variant: 'error',
                    });
            }
        }
        fetchData();
    }, [params.id]);

    return (
        <Box>
            <Box sx={styles.contentHeaderWrapper}>
                <Typography variant="h4">Customer</Typography>
                <CompanyMenu
                    Component={ActionButton}
                    row={{
                        id: params.id,
                        ...companyDetails,
                    }}
                    handleAction={() => navigate('/company')}
                />
            </Box>
            <Box sx={styles.contentBodyWrapper}>
                <Card {...props}>
                    <CardContent>
                        <Grid container direction="column" spacing={2}>
                            <Grid item>
                                <Button
                                    startIcon={<ChevronLeftIcon />}
                                    variant="text"
                                    color="secondary"
                                    onClick={() => navigate('/company')}
                                >
                                    Back
                                </Button>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <CompanyData company={companyDetails} />
                        </Grid>
                    </CardContent>
                </Card>
            </Box>
        </Box>
    );
};

export default View;
